export const isApnsSupported = (): boolean => {
  if (!window.electron?.isMac) {
    return false;
  }
  const version = window.electron.version;
  if (!version) {
    return false;
  }
  try {
    const [major, minor] = version.split('.').map(Number);
    return major > 2 || (major === 2 && minor >= 3);
  } catch {
    return false;
  }
};
